import React from 'react';

import { CardTrioCard } from '../../../components/CardTrio/CardTrioCard';
import { useLayoutContext } from '../../../providers/LayoutProvider';
import { AnalyticsController } from '../../Analytics';
import './NewsroomArticleAside.scss';
import { NewsroomArticleAsideSocialMediaLinks } from './NewsroomArticleAsideSocialMediaLinks';

export const NewsroomArticleAside = ({ node }) => {
    const { isPolicy } = useLayoutContext();
    return (
        <aside>
            {node.relationships?.field_news_author && (
                <h2 className="eyebrow">
                    Authored by: {node.relationships?.field_news_author?.title}
                </h2>
            )}
            {!isPolicy && <h2 className="eyebrow d-only">Share Article:</h2>}
            {!isPolicy && (
                <NewsroomArticleAsideSocialMediaLinks
                    className="d-only"
                    node={node}
                />
            )}

            {node.relationships?.field_related_articles?.length > 0 && (
                <>
                    <h2 className="related">Related News</h2>
                    <ul>
                        {node.relationships.field_related_articles.map(
                            (article, index) => {
                                const image =
                                    article.relationships.field_alternate_image
                                        ?.relationships?.field_media_image
                                        .localFile ??
                                    article.relationships.field_news_image
                                        ?.relationships?.field_media_image_1
                                        .localFile;

                                const category =
                                    article.relationships.field_news_category
                                        ?.name;

                                return (
                                    <CardTrioCard
                                        key={article + index}
                                        card={{
                                            id: article.id,
                                            news: true,
                                            linkUrl: article.fields.url,
                                            linkText: `Read more`,
                                            title: article.title,
                                            image: image ? image : undefined,
                                            imageAlt:
                                                article.relationships
                                                    ?.field_alternate_image
                                                    ?.field_media_image?.alt ??
                                                article.relationships
                                                    ?.field_news_image
                                                    ?.field_media_image_1.alt,
                                            eyebrow: category,
                                            description: image
                                                ? undefined
                                                : article.field_summary,
                                            onClick: () =>
                                                AnalyticsController.track({
                                                    event: `article click`,
                                                    articleLink: `related news: ${article.title}`,
                                                }),
                                        }}
                                    />
                                );
                            }
                        )}
                    </ul>
                </>
            )}
        </aside>
    );
};
